import React, { useContext } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { UserContext } from '../state/user/UserProvider'
import { isAdmin } from '../lib/user'

interface AdminRouteProps extends RouteProps {
  component: React.ComponentType<any>
}

/**
 * Protected route component that only allows admin users to access.
 * Non-admin users are redirected to the not-found page.
 */
export default function AdminRoute({
  component: Component,
  ...rest
}: AdminRouteProps) {
  const userContext = useContext(UserContext)

  return (
    <Route
      {...rest}
      render={(props) => {
        // Check if user is logged in and is an admin
        if (userContext && isAdmin(userContext)) {
          return <Component {...props} />
        }

        // Redirect non-admin users to not-found page
        return <Redirect to='/not-found' />
      }}
    />
  )
}
